module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/keith-money.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"54cbf245fe5a65cd37b0846f09945b0a"},
    },{
      plugin: require('../node_modules/gatsby-plugin-parsely-analytics/gatsby-browser.js'),
      options: {"plugins":[],"apikey":"keith.money","enableInDevelopment":false,"parselyCDN":"fpa-cdn.keith.money"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
